import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMemberDirectMessageLikedEmployeesIndexResponseType } from "~/domains/DirectMessage";

type RequestDataType = {
  directMessageId: string;
  page?: number;
};

const request = async ({
  directMessageId,
  page = 1,
}: RequestDataType): Promise<ApiMemberDirectMessageLikedEmployeesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiMemberDirectMessageLikedEmployeesIndexResponseType>(
      `/api/members/direct_messages/${directMessageId}/liked_employees`,
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  directMessageId: string;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisMembersDirectMessagesLikedEmployeesIndex = ({
  directMessageId,
  config = {},
}: PropsType): UseInfiniteQueryResult<ApiMemberDirectMessageLikedEmployeesIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisMemberDirectMessageLikedEmployeesIndex", directMessageId],
    ({ pageParam }) => {
      return request({
        directMessageId,
        page: pageParam as number | undefined,
      });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
